<template>
  <div>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
            @click="handleBack"
          >
            <feather-icon
              class="flex"
              icon="ArrowLeftIcon"
              svgClasses="w-6 h-6"
            />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Let's select a subscription plan to get started
          </h2>
        </div>
      </div>
    </div>
    <div class="p-8 bg-white fixed-top menu menucontrol-scroller">
      <div class="flex items-start justify-between gap-2">
        <!-- <p
          class="fsize14 text-primary flex cursor-pointer items-center gap-2 font-bold"
        >
          <feather-icon
            icon="ArrowLeftIcon"
            svgClasses="w-5 h-5"
            class="text-primary cursor-pointer"
          />
          Procastinate again
        </p> -->
        <!-- <img class="w-16 h-16" src="@/assets/images/new-log/second.png" alt="2" /> -->
      </div>

      <div>
        <div class="grid lg:grid-cols-4 grid-cols-1 gap-4 role p-2">
          <!-- <div class="grid lg:grid-cols-4 grid-cols-1 gap-4 role"> -->
          <div class="" v-for="(plan, index) in filteredPlans" :key="index">
            <div class="bg-white shadow rounded-lg p-2">
              <div class="px-5 py-8 rounded-lg bg-primary">
                <div class="flex gap-4" v-if="plan.name != 'Business'">
                  <img
                    v-if="['Free', 'Starter', 'Prototype'].includes(plan.name)"
                    class="w-5 h-5"
                    src="@/assets/images/new-log/dworld.png"
                    alt="white8"
                  />
                  <img
                    v-if="plan.name == 'Essential'"
                    class="w-5 h-5"
                    src="@/assets/images/new-log/white.png"
                    alt="white"
                  />
                </div>
                <div v-if="plan.name == 'Business'" class="flex">
                  <img
                    class="w-5 h-5 apps-gl object-contain"
                    :src="webIcon"
                    alt="white"
                  />
                  <img
                    class="w-5 h-5 object-contain apps-glr"
                    :src="androidIcon"
                    alt="white2"
                  />
                  <img
                    class="w-5 h-5 object-contain"
                    :src="appleIcon"
                    alt="white3"
                  />
                </div>
                <h1 class="fsize20 mt-2 text-white font-semibold">
                  {{ plan.name }} <br />subscription
                </h1>
              </div>
              <div class="flex mt-3 justify-center">
                <div>
                  <div class="block text-center 0 mb-4 mt-4">
                    <h2
                      class="text-dark font-bold fsize18"
                      v-if="plan.plans.length < 2"
                    >
                      {{
                        parseInt(plan.plans[0].price) === 0
                          ? "Forever Free"
                          : `₹${plan.plans[0].price.toLocaleString()}`
                      }}
                    </h2>
                    <h2
                      class="text-dark font-bold fsize18"
                      v-if="plan.plans.length > 1"
                    >
                      ₹{{
                        planDuration
                          ? plan.plans[1].price.toLocaleString()
                          : plan.plans[0].price.toLocaleString()
                      }}
                      <span class="fsize12"> / Monthly </span>
                      <p class="fsize10">billed Anually</p>
                      <div></div>
                    </h2>
                  </div>

                  <li>
                    <label for="">true / active</label>
                    <vs-switch v-model="switch1" />
                  </li>

                  <div
                    class="grid grid-cols-1 gap-2 text-left mt-2"
                    v-for="(feature, index) in plan.features"
                    :key="index"
                  >
                    <p class="font-semibold fsize12 text-center text-primary">
                      {{ feature.text }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="mt-12 items-end flex">
                <button
                  class="w-full cursor-pointer col-ed border-none rounded-12px fsize14 font-semibold py-4"
                  @click="processOrder(plan)"
                >
                  Get Started
                </button>
              </div>
            </div>
          </div>
          <!-- </div> -->

          <!-- <div class="swiper-pagination cust-posi" slot="pagination"></div> -->
        </div>
        <div class="lg:px-32 lg:mt-16 mt-6">
          <div
            class="flex justify-center w-full items-center lg:px-24 rounded-lg"
          >
            <div
              class="lg:flex cust-rev items-center w-full bg-primary overflow-hidden roundedenter"
            >
              <div class="lg:w-7/12 lg:px-16 lg:pb-10 lg:pt-10 pt-4 pb-10 px-6">
                <h1 class="font32-24px text-white">
                  {{ plans[5].name }}
                </h1>
                <p class="fsize13px text-white my-2">
                  {{ plans[5].description }}
                </p>
                <div class="grid grid-cols-1 gap-2 lg:my-4 my-4">
                  <div class="flex items-center gap-2">
                    <div class="w-4 h-4 bg-yellowish rounded-full"></div>
                    <p class="fsize13px text-white">Dedicated Developer</p>
                  </div>
                  <div class="flex items-center gap-2">
                    <div class="w-4 h-4 bg-yellowish rounded-full"></div>
                    <p class="fsize13px text-white">Flexible Pricing models</p>
                  </div>
                  <div class="flex items-center gap-2">
                    <div class="w-4 h-4 bg-yellowish rounded-full"></div>
                    <p class="fsize13px text-white">Access to code IP</p>
                  </div>
                </div>
                <button
                  @click="bookADemo"
                  class="px-8 cursor-pointer text-primary mt-2 lg:mt-4 border-none rounded-full fsize12 font-semibold py-3"
                >
                  Book a Demo
                </button>
              </div>
              <div class="lg:w-5/12 flex lg:justify-end">
                <div
                  class="glass-circle flex justify-center items-center margin-min-left"
                >
                  <img
                    src="@/assets/images/BA.svg"
                    alt="enterprice"
                    class="enter-img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  data() {
    return {
      plans: [],
      switch1: false,
      selectedProjectPlans: {},
      planDuration: true,
      freePlanRemovale: "",
      filteredPlans: [],
      webIcon: `${this.$imageURL}/brained/plans/globe.png`,
      androidIcon: `${this.$imageURL}/brained/plans/android.png`,
      appleIcon: `${this.$imageURL}/brained/plans/apple.png`,
    };
  },
  methods: {
    async getPlans() {
      const { data } = await this.$store.dispatch("billing/getAllPlans");
      this.plans = data;
      // for (let i = 0; i < this.plans.length; i++) {
      //   console.log(
      //     this.plans[i]._id ===
      //       this.selectedPlan[this.selectedPlan.length - 1].subscription._id,
      //     "Hello"
      //   );
      // }

      const planIndex = data.findIndex(
        (x) => x._id === this.selectedPlan[0].subscription._id
      );
      console.log(planIndex, "INDEXs");

      this.filteredPlans = data
        .filter(
          (x, index) =>
            x.name != "Prototype" && x.name != "Enterprise" && index > planIndex
        )
        .sort((a, b) => a.number - b.number)
        .map((x) => {
          // if (index > planIndex) {
          return { ...x, selected: false };
          // }
        });
    },
    bookADemo() {
      // this.$router.push("facebook.com");
      window.open("http://meet.brained.app/#/customer/book-a-demo", "_blank");
    },
    async processOrder(data) {
      this.selectedProjectPlans = {
        plans: data,
        billing: !this.planDuration
          ? data.plans[0]
          : data.plans[1]
          ? data.plans[1]
          : data.plans[0],
      };

      try {
        const data2 = await axios.post(
          "https://brained-hello-api.aiab.in/brained/payment/create_order",
          {
            amount: data.plans[1].price * 100 * 12,
            currency: "INR",
          }
        );
        console.log(data2.data, "PAY");
        const options = {
          key: process.env.VUE_APP_RAZORPAY_KEY,
          // amount:this.selectedPlan.
          currency: "INR",
          // descriptiopn:""
          order_id: data2.data.id,
          prefill: {
            name: this.login.name,
            email: this.login.email,
            contact: this.login.mobile,
          },
          handler: async (response) => {
            // alert(response.razorpay_order_id);
            await this.setUserPlans();
          },
        };
        const rzp = await new Razorpay(options);
        rzp.open();
      } catch (error) {
        console.log(error);
      }
    },
    async setUserPlans() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        subscription: this.selectedProjectPlans.plans._id,
        plan: this.selectedProjectPlans.billing,
        payment_status: "Paid",
        manHours: `${this.selectedProjectPlans.billing.boosters}`,
      };
      await this.$store.dispatch("billing/addBilling", payload);
      this.$router.push({ name: "dashboard" });
    },
  },
  async mounted() {
    await this.getPlans();
  },
  computed: {
    ...mapState("admin", ["selectedPlan"]),
    ...mapState("user", ["selectedProject"]),
    ...mapState("admin", ["login"]),
  },
};
</script>
<style>
.col-ed {
  background: #ededed !important;
}
.bg-pink-opacity {
  background: rgba(205, 49, 151, 0.24) !important;
}
.text-headert {
  font-size: 24 px !important;
}
.btnfix {
  padding: 10px;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
.hb300px {
  height: 300px;
  overflow-y: auto;
}
.hb300px::-webkit-scrollbar {
  width: 5px !important;
  background-color: #ececec !important;
}
.gap-tab {
  border: 1px solid #80808063;
  padding: 5px;
  border-radius: 999px;
  gap: 5px;
}
.tabchildpd {
  padding: 7px 20px;
  border-radius: 999px;
  font-size: 14px;
}
.custtab-active {
  background: #cd3197;
  color: #fff;
}
.text-424242 {
  color: #424242;
}
.bgprimary-light {
  background: #cd319778 !important;
}
.text-393939 {
  color: #393939;
}
.rounded-12px {
  border-radius: 12px;
}
.apps-gl {
  margin-right: 8px;
}
.apps-glr {
  margin-right: 5px;
}
.h-730px {
  height: 750px;
}
</style>
